module.exports = __webpack_public_path__ + "static/media/ic-zoom-in-grey.95249397.svg";